<form [formGroup]="formDatosComercialesyFacturadorE">
  <div class="row">
    <!-- Left -->
    <div class="col" style="max-width: 300px;">
      <div class="md-form">
        <input value="" type="text" id="nombreFantasia" class="form-control" placeholder="Nombre de Fantasia"
          #nombreFantasia formControlName="nombreFantasia" />
        <label for="nombreFantasia">Nombre de Fantasia</label>
        <!-- <div *ngIf="
                formDatosComercialesyFacturadorE.get('nombreFantasia').invalid &&
                (formDatosComercialesyFacturadorE.get('nombreFantasia').dirty ||
                formDatosComercialesyFacturadorE.get('nombreFantasia').touched)
                ">
                <mdb-error *ngIf="formDatosComercialesyFacturadorE.get('nombreFantasia').hasError('required')">Ingrese
                nombre de fantasía.</mdb-error>
            </div> -->
      </div>

    </div>
    <div class="col" style="max-width: 300px;">
      <div class="md-form">
        <input value="" type="text" id="giroComercial" class="form-control" placeholder="Giro comercial" required
          #giroComercial formControlName="giroComercial" />
        <label for="giroComercial">Giro comercial <app-required-field></app-required-field></label>
        <div *ngIf="
                            formDatosComercialesyFacturadorE.get('giroComercial').invalid &&
                            (formDatosComercialesyFacturadorE.get('giroComercial').dirty ||
                            formDatosComercialesyFacturadorE.get('giroComercial').touched)
                            ">
          <mdb-error *ngIf="formDatosComercialesyFacturadorE.get('giroComercial').hasError('required')">
            Ingrese
            giro comercial</mdb-error>
        </div>
      </div>


    </div>
  </div>

  <div class="row">
    <div class="col" style="max-width: 300px;">
      <h5 class="modal-title w-100 text-left" id="myModalLabel">
        Datos facturador electrónico
      </h5>
    </div>
  </div>

  <div class="row">
    <div class="col" style="max-width: 300px;">

      <div class="md-form">
        <input value="" type="text" id="emailIntercambio" class="form-control" placeholder="Email de intercambio"
          #emailIntercambio formControlName="emailIntercambio" />
        <label for="emailIntercambio">Email de intercambio</label>
        <div *ngIf="
                formDatosComercialesyFacturadorE.get('emailIntercambio').invalid &&
                (formDatosComercialesyFacturadorE.get('emailIntercambio').dirty ||
                formDatosComercialesyFacturadorE.get('emailIntercambio').touched)
                ">
          <!-- <mdb-error *ngIf="formDatosComercialesyFacturadorE.get('emailIntercambio').hasError('required')">
                    Ingrese email intercambio</mdb-error> -->
          <mdb-error *ngIf="formDatosComercialesyFacturadorE.get('emailIntercambio').hasError('maxlength')">
            Email intercambio no puede superar los 50 caracteres</mdb-error>
          <mdb-error *ngIf="formDatosComercialesyFacturadorE.get('emailIntercambio').hasError('email')">
            Email
            intercambio no válido</mdb-error>
        </div>
      </div>







    </div>
  </div>
  <div class="row">

    <div class="col" style="max-width: 300px;">
      <div class="md-form">
        <input value="" type="text" id="emailPDF" class="form-control" placeholder="Email envió PDF" #emailPDF
          formControlName="emailEnvioPdf" />
        <!-- [disabled]="formDatosComercialesyFacturadorE.get('usarMismoEmailContacto').value" -->
        <label for="emailPDF">Email envio PDF</label>
        <div *ngIf="
                        formDatosComercialesyFacturadorE.get('emailEnvioPdf').invalid &&
                        (formDatosComercialesyFacturadorE.get('emailEnvioPdf').dirty ||
                        formDatosComercialesyFacturadorE.get('emailEnvioPdf').touched)
                        ">
          <!-- <mdb-error *ngIf="formDatosComercialesyFacturadorE.get('emailEnvioPdf').hasError('required')">Ingrese
                            email envío PDF</mdb-error> -->
          <mdb-error *ngIf="formDatosComercialesyFacturadorE.get('emailEnvioPdf').hasError('maxlength')">
            Email
            envío PDF no puede superar los 50 caracteres</mdb-error>
          <mdb-error *ngIf="formDatosComercialesyFacturadorE.get('emailEnvioPdf').hasError('email')">
            Email envío
            PDF no válido</mdb-error>
        </div>
      </div>
    </div>

  </div>

</form>